<div class="modal-body p-3 p-md-4">

  <div class="d-flex align-items-start justify-content-between mb-3">
    <div class="d-flex align-items-center">
      <a class="clickable color-gray-400 me-2" *ngIf="step !== 'category'" (click)="back()">
        <i class="bi bi-chevron-left"></i>
      </a>
      <div>
        <p class="fs-normal fw-800 color-gray-950 mb-0">{{'planner.select_plan'|translate}}</p>
        <p class="fs-small fw-400 color-gray-400 mb-0">{{'planner.select_plan_' + step|translate}}</p>
      </div>
    </div>

    <a class="clickable color-gray-400 ms-2" (click)="modal.dismiss()" [ngbTooltip]="'buttons.close'|translate" container="body"><i class="bi bi-x-lg"></i></a>
  </div>

  <ngx-skeleton-loader
    *ngIf="isLoading" count="4" appearance="line"
    [theme]="{height: '44px', 'border-radius': '12px', margin: '0 0 8px 0'}"/>

  <ng-container *ngIf="!isLoading">
    <div class="row g-2" *ngIf="step === 'category'">
      <div class="col-12" *ngFor="let category of categories">
        <a class="option d-block p-3 clickable" (click)="selectCategory(category)">
          <p class="fs-small fw-800 color-gray-950 mb-0">{{category.title}}</p>
          <p class="fs-xsmall fw-400 color-gray-400 mb-0" *ngIf="category.plans?.length">
            {{'planner.plan_count'|translate: {count: category.plans.length} }}
          </p>
        </a>
      </div>

      <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!categories.length">
        {{'planner.no_plan_available'|translate}}
      </p>
    </div>

    <div class="row g-2" *ngIf="step === 'plan'">
      <div class="col-12" *ngFor="let plan of selectedCategory?.plans">
        <a class="option d-block p-3 clickable" (click)="selectPlan(plan)">
          <p class="fs-small fw-800 color-gray-950 mb-0">{{plan.title}}</p>
          <p class="fs-xsmall fw-400 color-gray-400 mb-0" *ngIf="plan.description">{{plan.description}}</p>
        </a>
      </div>
    </div>

    <div *ngIf="step === 'week'">
      <p class="fs-small fw-400 color-gray-400 mb-2">
        {{'planner.select_plan_week_desc'|translate: {plan: selectedPlan?.title} }}
      </p>

      <div class="row g-2">
        <div class="col-6 col-md-4" *ngFor="let week of weeks">
          <a class="option d-block text-center fs-small fw-800 p-2 clickable"
             [class.disabled]="isImporting" (click)="importToWeek(week)">
            {{'planner.week_number'|translate: {week: week.weekNumber} }}
          </a>
        </div>
      </div>
    </div>
  </ng-container>

</div>
